import { createHttpLink } from "apollo-link-http";
import { config } from "../config";

export const httpLink = createHttpLink({
  uri: config.serverUrl,
  credentials: "same-origin",
});
